import * as React from "react";
import styles from "./Artist.module.css";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import Header from "../../Components/Layout/Header";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";

import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import Parse from "../../API/ParseServer";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ArtworkCard from "../../Components/ArtworkCard/ArtworkCard";
import Footer from "../../Components/Layout/Footer";
import { useCart } from "../../Context/CartContext";

const Artist = () => {
  const params = useParams();
  const [artist, setArtist] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [artworks, setArtworks] = useState<any[]>();
  const [artworkChange, setArtworkChange] = useState(false);
  const { setTotalQuantity } = useCart();
  const artworkChangeHandler = () => {
    setArtworkChange((current) => !current);
  };
  useEffect(() => {
    const fetchArtist = async () => {
      const query = new Parse.Query("Artist");
      query.equalTo("name", params.artistName);
      try {
        const results = await query.find();
        if (results.length > 0) {
          setArtist(results[0]);
        } else {
          throw new Error("Artist not found.");
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArtist();
  }, [params.artistName]);
  useEffect(() => {
    const fetchArtworks = async () => {
      const query = new Parse.Query("Artwork");
      query.equalTo("artist", String(params.artistName));
      try {
        const results = await query.find();
        if (results.length > 0) {
          setArtworks(results);
        } else {
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArtworks();
  }, [artworkChange, params.artistName]);
  const [basket, setBasket] = useState();
  const [artworkQuantities, setArtworkQuantities] = useState();

  useEffect(() => {
    const fetchBasket = async () => {
      const user = Parse.User.current();

      if (user || localStorage.getItem("guestId")) {
        try {
          const basket = await Parse.Cloud.run("getBasket", {
            user: user ? user.id : localStorage.getItem("guestId"),
          });
          if (basket.get("status") !== "completed") setBasket(basket);
          const artworkQuantities: any = {};
          basket
            .get("items")
            .filter(
              (item: any) =>
                item.type === "ArtworkFrame" || item.type === "Artwork",
            )
            .forEach((item: any) => {
              const artworkId = item.artwork.id;
              artworkQuantities[artworkId] =
                (artworkQuantities[artworkId] || 0) + item.quantity;
            });
          setArtworkQuantities(artworkQuantities);
          let totalQuantity = 0;
          basket.get("items").forEach((item: any) => {
            totalQuantity += item.quantity;
          });
          setTotalQuantity(totalQuantity);
          localStorage.setItem("totalQuantity", String(totalQuantity));
        } catch (error) {
          console.error("Error fetching basket:", error);
        } finally {
          // setLoading(false);
        }
      }
    };
    fetchBasket();
  }, []);
  const [alertMessage, setAlertMessage] = useState("");

  const copyHandler = () => {
    window.navigator.clipboard.writeText(document.URL);
    setAlertMessage("Link Copied!");
    setTimeout(() => {
      setAlertMessage("");
    }, 1000);
  };
  return (
    <React.Fragment>
      {artist && (
        <Box
          sx={{
            width: "100%",
            backgroundColor: "transparent",
            position: "relative",
            height: "100%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#f5f5f5",
              position: "absolute",
              height: "100%",
              zIndex: -2,
            }}
          />
          <Container sx={{ py: 4 }}>
            <Grid
              container
              sx={{ justifyContent: "space-between", zIndex: 10 }}
            >
              <Grid item xs={12} md={4}>
                {artist.get("thumbnail") && (
                  <img
                    src={artist.get("thumbnail").url()}
                    alt={artist.get("name")}
                    style={{
                      backgroundColor: "gray",
                      width: "100%",
                      aspectRatio: "1",
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="h4" component="h2" sx={{ mt: 4 }}>
                  {artist.get("name")}
                </Typography>
                <Typography variant="h6">
                  b. {artist.get("birthday") && artist.get("birthday")}
                </Typography>
                <Typography variant="h6" sx={{ marginTop: 3 }}>
                  {artist.get("roles") &&
                    (artist.get("roles") as Array<string>).join(", ")}
                </Typography>

                <Box sx={{ marginTop: "auto" }}>
                  <IconButton onClick={copyHandler}>
                    <ShareOutlinedIcon sx={{ fontSize: "35px" }} />
                  </IconButton>{" "}
                  {alertMessage && <Typography>{alertMessage}</Typography>}
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "end" },
                }}
              >
                {}
              </Grid>
            </Grid>
          </Container>
          {artist.get("banner") && (
            <img
              src={artist.get("banner").url()}
              alt={artist.get("name")}
              style={{
                backgroundColor: "gray",
                height: "100%",
                marginRight: 0,
                // width: "100%",
                maxWidth: "100%",
                position: "absolute",
                right: 0,
                zIndex: -1,
                top: "0",
              }}
            />
          )}
        </Box>
      )}
      {artist && (
        <Container>
          <Box
            sx={{
              marginTop: 7,
              borderBottom: "2px solid #dad9da",
              width: "100%",
              mb: 5,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                display: "inline",
                boxShadow: "0 2px #0a0a0a",
                paddingBottom: "4px",
              }}
            >
              Biography
            </Typography>
          </Box>
          {artist.get("biography") &&
            artist.get("biography").map((item: any) => (
              <React.Fragment>
                <Typography variant="body1">{item}</Typography>
                <br />
              </React.Fragment>
            ))}

          {artist.get("credentials") && (
            <React.Fragment>
              <Box
                sx={{
                  mt: 5,
                  borderBottom: "2px solid #dad9da",
                  width: "100%",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    display: "inline",
                    boxShadow: "0 2px #0a0a0a",
                    paddingBottom: "4px",
                  }}
                >
                  Credentials
                </Typography>
              </Box>
              <Grid container sx={{ justifyContent: "space-between" }}>
                {artist.get("credentials").map((credential: any) => (
                  <Grid item xs={12} md={5.6} sx={{ mt: 3 }}>
                    <Typography variant="h6">{credential[0]}</Typography>
                    <Typography>{credential[1]}</Typography>
                  </Grid>
                ))}
              </Grid>
            </React.Fragment>
          )}
          <Box
            sx={{
              mt: 5,
              borderBottom: "2px solid #dad9da",
              width: "100%",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                display: "inline",
                boxShadow: "0 2px #0a0a0a",
                paddingBottom: "4px",
              }}
            >
              Artworks
            </Typography>
          </Box>
          <Grid container spacing={5} py={2}>
            {!artworks ? (
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Typography>No Artwork</Typography>
              </Grid>
            ) : (
              artworks.map((artwork: any) => (
                <ArtworkCard
                  artwork={artwork}
                  basket={basket}
                  artworkChangeHandler={artworkChangeHandler}
                  artworkQuantities={artworkQuantities}
                  grid={3}
                />
              ))
            )}
          </Grid>
        </Container>
      )}
    </React.Fragment>
  );
};

export default Artist;
